import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper, Alert } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import HomeIcon from '@mui/icons-material/Home';
import { useAuth } from '../hooks/useAuth';

const Unauthorized = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get the error message from location state if available
  const error = location.state?.error || "You don't have permission to access this page";
  
  // Get the role
  const role = user?.role || 'user';
  
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 64px)',
        padding: 3
      }}
    >
      <Paper 
        elevation={3} 
        sx={{ 
          padding: 4, 
          maxWidth: 600, 
          width: '100%', 
          textAlign: 'center',
          backgroundColor: 'background.paper'
        }}
      >
        <LockIcon sx={{ fontSize: 72, color: 'error.main', mb: 2 }} />
        
        <Typography variant="h4" component="h1" gutterBottom>
          Access Denied
        </Typography>
        
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
        
        <Typography variant="body1" paragraph>
          Your current role <strong>{role}</strong> does not have the necessary permissions to access this resource.
        </Typography>
        
        <Typography variant="body2" paragraph color="text.secondary">
          If you believe this is an error, please contact your administrator for assistance.
        </Typography>
        
        <Box sx={{ mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<HomeIcon />}
            onClick={() => navigate('/')}
            sx={{ mr: 2 }}
          >
            Go to Dashboard
          </Button>
          
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Unauthorized; 